import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "item-content" }
const _hoisted_2 = { class: "item-icon" }
const _hoisted_3 = { class: "item-body" }
const _hoisted_4 = { class: "item-title-row" }
const _hoisted_5 = { class: "item-title no-overflow" }
const _hoisted_6 = { class: "item-subtitle no-overflow" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "btn-highlight-label" }
const _hoisted_9 = ["checked"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompactItem',
  props: {
    pageUrl: {},
    static: { type: Boolean },
    selectMode: { type: Boolean },
    statusText: {},
    statusStyle: {},
    small: { type: Boolean },
    shadow: { type: Boolean },
    raised: { type: Boolean },
    noHover: { type: Boolean },
    showHover: { type: Boolean },
    highlightMode: { type: Boolean },
    highlighted: { type: Boolean },
    highlightSource: { type: Boolean },
    highlightSourceSelected: { type: Boolean }
  },
  emits: ["click", "highlight"],
  setup(__props: any, { emit }) {

const props = __props;





const selectModeRef = computed(() => !props.static && props.selectMode)
const linkModeRef = computed(() => !props.static && !props.selectMode && props.pageUrl)
const isInteractiveRef = computed(() => selectModeRef.value || linkModeRef.value)
const showHighlightSourceRef = computed(() => props.highlightMode && props.highlightSource)

const itemClassRef = computed(() => {
  return {
    ['item-small']: props.small,
    ['item-shadow']: props.shadow,
    static: props.static,
    raised: props.raised,
    ['show-hover']: (isInteractiveRef.value && !props.noHover) || props.showHover,
    ['highlight-source']: showHighlightSourceRef.value,
  }
})

function onHighlightChange(e: Event) {
  const ch = e.target as HTMLInputElement
  emit('highlight', ch.checked)
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["compact-item", itemClassRef.value])
  }, [
    (selectModeRef.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "overlay",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
        }))
      : (linkModeRef.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: _ctx.pageUrl!,
            class: "overlay"
          }, null, 8, ["to"]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          (_ctx.$slots.statusText)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["item-status badge", props.statusStyle])
              }, [
                _renderSlot(_ctx.$slots, "statusText")
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "subtitle")
        ])
      ]),
      (showHighlightSourceRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "btn-highlight",
                checked: _ctx.highlightSourceSelected,
                onChange: onHighlightChange
              }, null, 40, _hoisted_9)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})